import ArticleIcon from '@mui/icons-material/Article';

const doctorRoutes = [
  {
    name: 'Consultas',
    link: '/consultas',
    icon: <ArticleIcon />
  }
];

export default doctorRoutes;
